export interface Dict {
  [key: string]: any;
}

export enum ApiStatus {
  Success = 0,
  NotPresent,
  DuplicateOrConflict,
  Validation,
  Unknown,
}

export interface ApiResponse {
  statusCode: number;
  detail: string;
  title: string;
}

export interface Backend {
  url: string;
}

// This is the core information we get when we query the backend, that is,
// an image name, its source and the votes it has so far
export interface ImageRef {
  image_id: string;
  src: string;
  small_img_src: string;
  votes: number;
  rnd: string;
  winner: boolean;
  opensea_link?: string;
}

//
export interface Image {
  image_id: string;
  src: string;
  thumbnail: string;
  thumbnailWidth: number;
  thumbnailHeight: number;
  isSelected: boolean;
  isWinner: boolean;
  votes: number;
  round: string;
  enableImageSelection: boolean;
  thumbnailCaption: string;
  selectionRank: number;
  openseaLink: string;
}

export interface Entropy {
  address: string;
  has_submitted: boolean;
}

export interface RoundRef {
  name: string;
  active: boolean;
  vote: boolean;
  end_time: string;
  n_votes?: number;
  n_winners?: number;
  title?: string;
}

export interface CountDown {
  [key: string]: string;
}

export interface UserVote {
  address: string;
  has_submitted: boolean;
}

export interface UserImage {
  src: string;
  rank: number;
  rnd: string;
}

export interface Winner {
  address: string;
  stake: number;
  slots: number;
  reward?: number;
}